import * as GlobalActions from './global'
import * as UserActions from './user'
import * as NewsActions from './news'
import * as LocationsActions from './locations'

const ActionCreators = {
  ...GlobalActions,
  ...UserActions,
  ...NewsActions,
  ...LocationsActions,
}

export default ActionCreators
